import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DeliveryEventType } from '../../../interfaces/myDataDelivery.interface';
import { DeliveryStatusStep } from './DeliveryStatusStep';

interface Props {
  lifecycleHistory: DeliveryEventType | DeliveryEventType[] | undefined;
}

export const DeliveryStatusSteps = ({ lifecycleHistory }: Props) => {
  const { t } = useTranslation();

  const lifecycleSteps: DeliveryEventType[] = useMemo(() => {
    if (!lifecycleHistory) return [];
    if (Array.isArray(lifecycleHistory)) return lifecycleHistory;
    return [lifecycleHistory];
  }, [lifecycleHistory]);

  if (lifecycleSteps.length === 0) return null;

  return (
    <div className="width-100">
      <div className="flex-center-center-column-nowrap width-100">
        <div className="boldText6 width-100 m-b-16" style={{ textAlign: 'center' }}>
          {t('DELIVERY.DELIVERY_LIFECYCLE_HISTORY')}
        </div>

        <div className="flex-center-start-row-wrap gap-16 width-100">
          {lifecycleSteps.map((step, index) => (
            <div key={index} className="min-width-300px max-width-440px flex1">
              <DeliveryStatusStep step={step} stepNumber={index + 1} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
